<template>
  <div class="Maintenance">
    <section-header heading="2" ja="メンテナンスのお知らせ"/>
    <div class="textAreaa">
      現在『プリクラON』のメンテナンスを行っております。<br>
      メンテナンス時間中は『プリクラON』をご利用いただけません。<br>
      <br>
      ■対応日時<br>
      2021年2月10日(水) 06:00～08:00(予定)<br>
      ※時間は前後することがございます。<br>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
export default {
  components: {
    SectionHeader,
  },
  mixins: [],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="scss">
.textAreaa {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
